// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HvcS","colMin":"styles_colMin__3XEM9"};